import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import { AccordionProvider } from './AccordionProvider';

type AccordionProps = {
  id?: string;
  children?: ReactNode;
  multiple?: boolean;
  value?: string | string[];
  defaultValue?: string | string[];
  onChange?: (value: string | string[]) => void;
  transitionDuration?: number;
  loop?: boolean;
} & ComponentPropsWithoutRef<'div'>;

const Accordion = forwardRef<HTMLDivElement, AccordionProps>(
  (
    { id, children, multiple, value, defaultValue, onChange, transitionDuration, loop, ...rest },
    ref
  ) => (
    <AccordionProvider
      id={id}
      multiple={multiple}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      transitionDuration={transitionDuration}
      loop={loop}
    >
      <div {...rest} ref={ref} data-accordion>
        {children}
      </div>
    </AccordionProvider>
  )
);

Accordion.displayName = 'Accordion';

export { Accordion };
export type { AccordionProps };
